import * as yup from 'yup';
import {
  DEFAULT_MAX_LENGTH,
  EMAIL,
} from '../../../utils/validation/validationRules';
import { validationErrors } from '../../../utils/validation/validationErrors';

export const landingValidationSchema = yup.object().shape({
  first_name: DEFAULT_MAX_LENGTH.required(validationErrors.REQUIRED_FIELD),
  last_name: DEFAULT_MAX_LENGTH.required(validationErrors.REQUIRED_FIELD),
  email: EMAIL.required(validationErrors.REQUIRED_FIELD),
  professional_title: DEFAULT_MAX_LENGTH.required(validationErrors.REQUIRED_FIELD),
});
